import { GET_CAMERA_CLASSES_REQUESTED } from "./type";

export const getCameraClassesRequested = (token: string) => {
  return {
    type: GET_CAMERA_CLASSES_REQUESTED,
    token
  };
};
